// extracted by mini-css-extract-plugin
export default {"about-wrapper":"about_about-wrapper__pQaWE","about":"about_about__XtGV4"};